import React from 'react';

import classes from '../../SalesLogic/InstallImages/installPics.css';

import Pic from '../../../../../../assets/Fortress5.jpg';

const Pic1
 = () => (
     <div className={classes.installImages}>
         <img alt="Fortress Power 5kWh Battery" src={Pic} className={classes.installImg} />
     </div>
 );


export default Pic1;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/EnergyStoragePics/Fortress5.js